/**
 * Category may live on deployment_config.category (legacy / admin) or
 * deployment_config.classification.category (newer shape).
 */
export function getDeploymentCategory(unit) {
    if (!unit?.deployment_config) return undefined;
    const dc = unit.deployment_config;
    return dc.category || dc.classification?.category;
}

export function isDangerousWasteDeploymentUnit(unit) {
    return getDeploymentCategory(unit) === 'dangerous_waste';
}
